'use client';
import React from 'react';
import { AuthLayout } from './auth-layout';
import { BaseLayout } from './base-layout';
import { useUser } from '@/shared/providers/user-provider/use-user';
import { SkeletonLayout } from './skeleton-layout';

const Layout: React.FC = ({ children, flexMain = false }) => {
  const { user } = useUser();
  // if (!user.isUserLoading) {
  //   return <SkeletonLayout>{children}</SkeletonLayout>;
  // }

  if (user.isAuth) {
    return <AuthLayout flexMain={flexMain}>{children}</AuthLayout>;
  }

  if (!user.isAuth && !user.isUserLoading) {
    return <BaseLayout flexMain={flexMain}>{children}</BaseLayout>;
  }
};

export { Layout };
